"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { AgentAudioVisualizerAura } from "@/components/agents-ui/agent-audio-visualizer-aura";
export function AudioVisualizer({ agentState, audioTrack, }) {
    const [themeMode, setThemeMode] = useState("light");
    useEffect(() => {
        // When embedded in a shadow DOM (external sites), detect theme from the
        // shadow host element (#lk-embed-wrapper). The host has a "dark" class
        // when dark mode is active; otherwise default to light mode.
        const embedWrapper = document.getElementById("lk-embed-wrapper");
        const getThemeMode = () => {
            if (embedWrapper) {
                return embedWrapper.classList.contains("dark") ? "dark" : "light";
            }
            return document.documentElement.classList.contains("dark")
                ? "dark"
                : "light";
        };
        setThemeMode(getThemeMode());
        const target = embedWrapper !== null && embedWrapper !== void 0 ? embedWrapper : document.documentElement;
        const observer = new MutationObserver(() => {
            setThemeMode(getThemeMode());
        });
        observer.observe(target, {
            attributes: true,
            attributeFilter: ["class"],
        });
        return () => observer.disconnect();
    }, []);
    return (_jsx(AgentAudioVisualizerAura, { size: "xl", state: agentState, audioTrack: audioTrack, themeMode: themeMode, color: "#1A4C9C", colorShift: 0.03 }));
}
